export enum SnackMessageType {
    None,
    Error
}
export class SnackMessageVo {
    public message: string = '';
    public messageType: SnackMessageType = SnackMessageType.None
}